import { memo } from 'react';

import { Space, Typography } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';

import { makeMainGEvent, pushEvent } from '../../utils/analytics';

import styles from './variant-b-invite-a-friend.module.scss';

const handleClick = () => {
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Пригласи друга',
      eventAction: 'Пригласить',
    }),
  );
};

export const InviteAFriend = memo(() => {
  const cx = useStyles(styles);

  return (
    <a
      href={'/promo/sharefriend/'}
      target={'_blank'}
      className={cx('wrapper', 'invite')}
      rel="noreferrer"
      onClick={handleClick}
    >
      <img src={require(`../../public/images/invite-a-friend.svg`)} alt={''} className={cx('picture')} />
      <Space size={16} direction={'horizontal'} align={'center'} justify={'space-between'} className={cx('texts')}>
        <Typography.Text size={14} strong>
          Получите кэшбек
          <br />
          до{'\u00A0'}2{'\u00A0'}000{'\u00A0'}₽
        </Typography.Text>
        <Typography.Text size={14} className={cx('text-friends')}>
          За приглашённых
          <br />
          друзей
        </Typography.Text>
        <Typography.Text size={14} className={cx('text-link')} strong>
          Пригласить
        </Typography.Text>
      </Space>
    </a>
  );
});
